export default "__VITE_ASSET__yiPuPXYi__"